export default __webpack_public_path__ + "static/media/couple.8aeae0d6.jpg";